import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { axiosInstance } from "../../utils/util.axios";
import lottie from "lottie-web";
import successData from "../../assets/loading-credentials.json";
import styles from "./SSOLogin.module.scss";
import { handleSSOError } from "../../store/actions/GeneralActions";
import Loading from "../../components/SSO/Loading";

const SSORegister = () => {
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();
    const dispatch = useDispatch();
    
    const getKeycloakAuthUrl = async () => {
        try {
            const res = await axiosInstance.get("/auth_registration_url");
            if (res.data.url) {
                window.location.href = res.data.url;
            } else {
                dispatch(handleSSOError("No redirect URL"));
            }
            setIsLoading(false);
            history.push("/");
        } catch (error) {
            setIsLoading(false);
            dispatch(handleSSOError("Error fetching redirect URL"));
            history.push("/");
        }
    };

    useEffect(() => {
        lottie.loadAnimation({
            container: document.querySelector("#ssoLottie"),
            animationData: successData,
            loop: true,
            autoplay: true
        });
        getKeycloakAuthUrl();
    }, []);
    

    return (
        <div className={styles.container}>
            {isLoading && <Loading />}
        </div>
    );
};

export default SSORegister;
